export default "__VITE_ASSET__Brf82zqa__"